import { memo, useCallback } from 'react'

import { Divider } from '@mui/material'
import { ImageBlob } from '@nativewaves/nw-cloud-sdk/content'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useImageBlobDeleteMutation } from 'hooks/mutations/content/ImageObject'
import { imageBlobsOverviewRoute } from 'pages/NWPlatform/Workspaces/Workspace/Images/Image/Blobs/Routing'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<ImageBlob>) => {
  const { imageId } = imageBlobsOverviewRoute.useParams()
  const { mutate: deleteImageBlob } = useImageBlobDeleteMutation()

  const handleDeleteImageBlob = useCallback(() => {
    onClose()

    setTimeout(() => {
      deleteImageBlob({ imageId, blobId: row.original.id })
    }, 300)
  }, [deleteImageBlob, onClose, row.original.id, imageId])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider component="li" />
      <MenuItemDelete onConfirm={handleDeleteImageBlob} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
